import { sectionCountsFromMembership } from '@axilon-apps/domains-ontology-ui-state'

type SectionedMark = { sections: readonly string[] }
type JobLevelMark = { jobLevel: boolean }

/** Same membership helper as the job page, fed from the paint mark maps. */
export function sectionCountsFromMarks(
  ...markMaps: ReadonlyArray<ReadonlyMap<string, SectionedMark>>
): Map<string, number> {
  const sectionsByEntity: Record<string, string[]> = {}
  for (const markById of markMaps) {
    for (const [id, entry] of markById) {
      if (entry.sections.length > 0) sectionsByEntity[id] = [...entry.sections]
    }
  }
  return sectionCountsFromMembership(sectionsByEntity)
}

export function jobLevelCountFromMarks(
  ...markMaps: ReadonlyArray<ReadonlyMap<string, JobLevelMark>>
): number {
  let count = 0
  for (const markById of markMaps) {
    for (const entry of markById.values()) {
      if (entry.jobLevel) count += 1
    }
  }
  return count
}

export function allChangesCountFromMarks(
  ...markMaps: ReadonlyArray<ReadonlyMap<string, unknown>>
): number {
  let count = 0
  for (const markById of markMaps) count += markById.size
  return count
}
